import React from 'react';

import styled from '@emotion/styled';
import { Badge } from '@lightspeed/flame/Badge/next';

import { createReactRenderer } from 'root/apps/helpers/react-renderer';

import useLocationPreauths from '../RegisterCustomerPreauths/hooks/useLocationPreauths';

const StyledBadge = styled(Badge)`
  margin-left: 8px;
  letter-spacing: 0;
  text-transform: none;
`;

const PreauthExpiringBadge: React.FC = () => {
  const expiringBefore = React.useMemo(() => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
  }, []);

  const { preauths, isLoading, isError } = useLocationPreauths(expiringBefore);

  const expiringCount = preauths.length;

  if (isLoading || isError || expiringCount <= 0) {
    return null;
  }

  return (
    <StyledBadge variant="warning" data-automation="preauth-expiring-badge">
      <var>{expiringCount}</var>&nbsp;expiring soon
    </StyledBadge>
  );
};

const RenderedComponent = createReactRenderer({
  component: PreauthExpiringBadge,
  selector: '[data-react-root="PreauthExpiringBadge"]',
});

history.onChangeState(
  { form_name: 'ui_tab', tab: 'register' },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

export default PreauthExpiringBadge;
